const baseUrl = (() => {
    // return 'https://hormone.herokuapp.com';
    // return 'http://localhost:8000';
    return 'https://khf.azurewebsites.net';
})();

export default baseUrl;
